import { FC } from "react";

interface BellIconSVGProps {
    className?: string;
}

const BellIconSVG: FC<BellIconSVGProps> = (props) => {
    return (
        <svg
            className={props.className}
            width="36"
            height="36"
            viewBox="0 0 36 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M15.45 31.5C15.7011 31.9567 16.0702 32.3375 16.5187 32.6028C16.9673 32.8681 17.4789 33.008 18 33.008C18.5211 33.008 19.0327 32.8681 19.4813 32.6028C19.9298 32.3375 20.2989 31.9567 20.55 31.5M9 12C9 9.61305 9.94821 7.32387 11.636 5.63604C13.3239 3.94821 15.6131 3 18 3C20.3869 3 22.6761 3.94821 24.364 5.63604C26.0518 7.32387 27 9.61305 27 12C27 22.5 31.5 25.5 31.5 25.5H4.5C4.5 25.5 9 22.5 9 12Z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default BellIconSVG;
